import React, { Component } from "react";
import "./NotificationCard.css";
import Icon from '../../Icon/Icon';
import ConsoleLog from './../../../../hoc/ConsoleLog/ConsoleLog';

/**
 * @desc NotificationCard
 * @param props
 * @return null
 */
const NotificationCard = props => {
  
  const statusClass = (props.status==='NEW') ? 'notification-card ' : 'notification-card notification-read ' ;
  return (
    <React.Fragment>
      <div className = {statusClass + props.className} style={props.notificationStyle} id={props.cardId}>
        <div className="notification-time">{props.time}</div>
        <Icon icon={props.icon} className="notification-type-icon"></Icon>
        <div className="notification-message" dangerouslySetInnerHTML={{__html:props.content}}></div>
        <Icon icon="close-icon" className="notification-remove" onClick={()=>props.handleRemoveNotification()}></Icon>   
      </div>
    </React.Fragment>
  );
};

export default NotificationCard;



// WEBPACK FOOTER //
// ./src/components/UI/Notification/NotificationCard/NotificationCard.js